import { crmApiInstance } from './client.js';

export const leadsApi = {
  getAll:         (params = {}) => crmApiInstance.get('/leads', { params }).then(r => r.data),
  getDormant:     (params = {}) => crmApiInstance.get('/leads/dormant', { params }).then(r => r.data),
  getStatusFlags: ()            => crmApiInstance.get('/leads/status-flags').then(r => r.data),
  getColumnValues: (params = {}) => crmApiInstance.get('/leads/column-values', { params }).then(r => r.data),
  getById:        (id)          => crmApiInstance.get(`/leads/${id}`).then(r => r.data),
  getProfile:     (id)          => crmApiInstance.get(`/leads/${id}/profile`).then(r => r.data),
  getOrders:      (id, params)  => crmApiInstance.get(`/leads/${id}/orders`, { params }).then(r => r.data),
  getTimeline:    (id, params)  => crmApiInstance.get(`/leads/${id}/timeline`, { params }).then(r => r.data),
  create:         (payload)     => crmApiInstance.post('/leads', payload).then(r => r.data),
  update:         (id, payload) => crmApiInstance.put(`/leads/${id}`, payload).then(r => r.data),
  remove:         (id)          => crmApiInstance.delete(`/leads/${id}`).then(r => r.data),
  triggerCall:    (id, payload) => crmApiInstance.post(`/leads/${id}/call`, payload).then(r => r.data),
  logEmail:       (id, payload) => crmApiInstance.post(`/leads/${id}/email`, payload).then(r => r.data),
  bulkAssign:     (payload)     => crmApiInstance.put('/leads/bulk-assign', payload).then(r => r.data),
  getLocations:   (id, params)  => crmApiInstance.get(`/leads/${id}/locations`, { params }).then(r => r.data),
  createLocation: (id, data)    => crmApiInstance.post(`/leads/${id}/locations`, data).then(r => r.data),
  updateContacts: (id, contacts) => crmApiInstance.put(`/leads/${id}/contacts`, { contacts }).then(r => r.data),
};
